/**
 * Turn a stored image reference into something an `<img src>` can load.
 *
 * The server stores uploads as a path relative to the data root — "data/img/…".
 * That string is NOT a URL: putting it straight into an `<img src>` renders a
 * broken image, and it is how the catalog cards came up empty. It needs a
 * leading slash; anything else (an endpoint, an absolute URL, a data: URI) is
 * already a URL and is left exactly as it is.
 *
 * One function, because this rule was written out by hand in five components
 * and a sixth would eventually get it wrong.
 */
export function imageSrc(ref: string | null | undefined): string | null {
  if (!ref) return null;
  return ref.startsWith('data/') ? `/${ref}` : ref;
}
